"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var types_1 = __importDefault(require("../types"));
var processMessage_1 = __importDefault(require("./helpers/processMessage"));
function chatRoomMessageQueueReducer(state, action) {
    var _a;
    var _b, _c, _d;
    switch (action.type) {
        case types_1["default"].MESSAGE_QUEUE_ADD: {
            var _e = action.payload, roomId = _e.roomId, attachment = _e.attachment, text = _e.text;
            var attachments = [];
            if (attachment)
                attachments.push(attachment);
            var ts = moment_1["default"]().toISOString();
            var queuedMessage = processMessage_1["default"]({
                _id: ts,
                rid: roomId,
                msg: text,
                isQueued: true,
                u: {
                    _id: ((_b = state.me) === null || _b === void 0 ? void 0 : _b._id) || '',
                    name: ((_c = state.me) === null || _c === void 0 ? void 0 : _c.name) || '',
                    username: ((_d = state.me) === null || _d === void 0 ? void 0 : _d.username) || ''
                },
                ts: ts,
                attachments: attachments,
                isSystem: false,
                _updatedAt: moment_1["default"]().toISOString()
            });
            var room = state.rooms[roomId];
            if (!room) {
                console.error('MESSAGE_QUEUE_ADD: Room not found:', roomId);
                return state;
            }
            var queue = room.messageQueue || [];
            room = room.merge({
                messageQueue: queue.concat(queuedMessage)
            });
            return state.setIn(['rooms', roomId], room);
        }
        case types_1["default"].MESSAGE_QUEUE_REMOVE: {
            var _f = action.payload, _id_1 = _f._id, roomId = _f.roomId;
            var room = state.rooms[roomId];
            if (lodash_1["default"].isEmpty(room === null || room === void 0 ? void 0 : room.messageQueue))
                return state;
            var messageQueue = room.messageQueue.filter(function (message) { return message._id !== _id_1; });
            room = room.merge({
                messageQueue: messageQueue.asMutable({ deep: true })
            });
            return state.merge({
                rooms: state.rooms.merge((_a = {},
                    _a[roomId] = room,
                    _a))
            });
        }
        case types_1["default"].MESSAGE_QUEUE_ERROR: {
            var _g = action.payload, roomId = _g.roomId, isErrored_1 = _g.isErrored, _id_2 = _g._id;
            var room = state.rooms[roomId];
            if (lodash_1["default"].isEmpty(room === null || room === void 0 ? void 0 : room.messageQueue))
                return state;
            var messageQueue = room.messageQueue.asMutable({ deep: true }).map(function (message) {
                if (_id_2 && message._id !== _id_2)
                    return message;
                message.isErrored = isErrored_1;
                return message;
            });
            room = room.merge({
                messageQueue: messageQueue
            });
            return state.setIn(['rooms', roomId], room);
        }
        default:
            return state;
    }
}
exports["default"] = chatRoomMessageQueueReducer;
